@if (!listLoading()) {
  <div class="w-100 ap-mb-spacing-5">
    <gstar-combobox
      [required]="required"
      [label]="placeholder"
      [options]="incomeTypes()"
      keyProp="name"
      valueProp="taxResultItemTypeId"
      trackByKey="taxResultItemTypeId"
      [value]="value"
      [disabled]="disabled || !currentSecurityTypeId"
      (selectItem)="selectIncomeTypeHandler($event)"
      (clearValue)="clearIncomeTypeHandler()" />
  </div>
}
